import * as React from 'react';
import * as _ from 'lodash';
import * as Styles from './styles';
import { KEYS } from 'common/constants';
// import { TEMPLATE_CAMPAIGN_TEXT } from 'common/texts';
import delayUnmounting from 'features/Dealers/DealerConfiguration/Modals/delayUnmounting';
// import { ActionBarOptions } from 'features/Templates/DuplicateTemplate/styles';
import ActionBar from 'components/ActionBar';

import {
    Container,
    Title,
    TitleContainer,
    Body,
    BodyText,
    ButtonContainer,
    Notice,
    SuccessText,
    ErrorText
} from 'features/Dealers/DealerConfiguration/Modals/styles';
import Modal from 'components/Modal';
import { ModalTitle } from 'common/styles';

export interface ModalStopProps {
    onStopConfirmed: () => void;
    onCancel: () => void;
    onOKClose: () => void;
    shouldShow: boolean;
    isSyncing: boolean;
    errormessage?: string;
    successmessage?: string;
}

export interface ModalSyncStates {
    synced?: boolean;
}

class ModalStop extends React.Component<ModalStopProps, ModalSyncStates> {

    constructor(props: ModalStopProps) {
        super(props);
        this.state = {
            synced: false,
        };
        this.onCancelClick = this.onCancelClick.bind(this)
        this.onOKCloseClick = this.onOKCloseClick.bind(this)
        this.onStopConfirmed = this.onStopConfirmed.bind(this)
    }

    onStopConfirmed() {
        this.props.onStopConfirmed();
        this.setState({ synced: true });
    }

    onCancelClick() {
        this.props.onCancel();
    }

    onOKCloseClick() {
        this.props.onOKClose();
    }

    keyDownHandle = (e) => {
        if (e.key === KEYS.ESCAPE) {
            this.props.onCancel()
        }
    }

    render() {
        return (
            <Modal shouldShow={this.props.shouldShow}>
            <Container onKeyDown={this.keyDownHandle} shouldShow={this.props.shouldShow}>
                    <ModalTitle> Stop Automatic Sync</ModalTitle>
                <Body>
                    <BodyText>
                        By stopping the automatic sync, this account won't be able to:
                        <ul>
                            <li>
                            Automatically update with current CMS information.
                            </li>
                            <li>
                            Publish ESM or Symphony Specials to GBP.
                            </li>
                        </ul>
                        Are you sure you want to stop syncing this dealer?
                    </BodyText>                 
                </Body>
                
                <ButtonContainer>
                    <ActionBar
                        mainActionLabel={"YES"}
                        mainActionLoading={this.props.isSyncing}
                        secondaryActionLabel={"NO"}
                        onMainActionClick={this.onStopConfirmed}
                        onSecondaryActionClick={this.onCancelClick}
                    />
                </ButtonContainer>
            </Container>
        </Modal>





     
        );
    }
}

export default delayUnmounting<ModalStopProps>(ModalStop);